import {ValueObject} from '@s-ui/domain'

export class PaymentUrlTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.paymentUrl
   */

  static create = ({paymentUrl}) => {
    return new PaymentUrlTransactionsValueObject({
      paymentUrl
    })
  }
}
